import {
  Checkbox,
  Heading,
  SelectDropdown,
  AgGrid,
  MobileResponsiveGrid,
} from "@/common/components";
import { sortByName } from "@/utils/Utilities";

const ProfileInformation = ({
  accessProfiles,
  currentAccessProfile,
  selectedEntity,
  dataAccessRules,
  setDataAccessRules,
  addNoAccess = false,
  showOperatorId = true,
  showCheckbox = false,
  adminChecked,
  setAdminChecked,
  labels,
  showCurrentAccess = true,
}) => {
  const getAccessLevel = (approvedId) => {
    const profiles = accessProfiles?.accessProfiles;

    if (profiles) {
      let data = profiles.filter((e) => e.typeCode === selectedEntity);

      sortByName(data);

      if (approvedId) {
        data = data.filter((e) => e.id !== approvedId);
      }

      if (selectedEntity === "R" || addNoAccess) {
        data.unshift({
          id: 0,
          name: labels?.noAccess,
        });
      }

      return data;
    } else {
      return [];
    }
  };

  const Dropdown = (params) => {
    return (
      <SelectDropdown
        id="accessLevel"
        dropdownData={getAccessLevel(params?.data?.approveAccessProfile?.id)}
        wrapperClassName="mb-0 py-2"
        selectClassName="w-100 py-2"
        select={(e) => {
          dataAccessRules[params.node.rowIndex].requestAccessProfile.id = e;
          setDataAccessRules([...dataAccessRules]);
        }}
        value={params.data.requestAccessProfile.id}
        optionId="id"
        optionLabel="name"
        defaultOption={addNoAccess}
        ariaLabel="Access Level"
      />
    );
  };

  const columnDefs = [
    {
      headerName: labels?.productManufacturer,
      field: "productSponsor.name",
    },
    {
      headerName: labels?.currentAccessLevel,
      field: "approveAccessProfile.name",
    },
    {
      headerName: labels?.newAccessLevel,
      cellRenderer: Dropdown,
    },
  ];

  const defaultColDef = {
    cellClass: "d-flex align-items-center",
  };

  const onGridReady = (params) => {
    params.api.setColumnVisible("approveAccessProfile.name", showCurrentAccess);
  };

  return (
    <section className="mb-4">
      <Heading
        text={labels?.profileInformation}
        wrapperClassNames="h4 border-bottom-1 pb-2"
        title={false}
      />

      {showOperatorId && (
        <div className="mb-3">
          <span className="fw-bold">{labels?.operator}</span>
          {currentAccessProfile?.operatorId}
        </div>
      )}

      {showCheckbox && (
        <Checkbox
          wrapperClassName="my-3"
          label={labels?.operatorIsRICCAdmin}
          value={adminChecked}
          id="admin-checkbox"
          name="admin-checkbox"
          change={(e) => setAdminChecked(e)}
        />
      )}

      {currentAccessProfile?.insuranceCompany && (
        <div className="my-3">
          <strong>{labels?.insuranceCompany}</strong>
          {currentAccessProfile?.insuranceCompany?.companyName}
        </div>
      )}

      {!adminChecked && (
        <>
          <AgGrid
            columnDefs={columnDefs}
            rowData={dataAccessRules}
            defaultColDef={defaultColDef}
            domLayout="normal"
            onGridReady={onGridReady}
            overlayNoRowsTemplate={labels?.productManufacturerDoesNotExist}
            wrapperClassNames="d-none d-md-block"
          />
          <MobileResponsiveGrid
            rowData={dataAccessRules}
            columnDefs={columnDefs}
            showSortDropDown={false}
            noDataLabel={labels?.productManufacturerDoesNotExist}
          />
        </>
      )}
    </section>
  );
};

export default ProfileInformation;
